module.exports = __webpack_public_path__ + "static/media/pencil-board.635b6d8f.jpeg";